<template>
  <div class="level-formulae">
    <v-data-table
      :headers="headers"
      :items="levelFormulae"
      :loading="isLoading"
      hide-default-footer
      disable-pagination
      height="calc(100vh - 48px)"
    >
      <template #item.settings.hold_level="{value}">
        <v-switch :input-value="value" disabled />
      </template>
      <template #item.settings.slow_drop="{value}">
        <v-switch v-if="typeof value === 'boolean'" :input-value="value" disabled />
      </template>
      <template #item.entities="{value}">
        {{ getEntityList(value) }}
      </template>
      <template #item.action="{item}">
        <v-icon
          @click="formulaToEdit = item, isUpserting = true"
        >
        edit
        </v-icon>
      </template>
      <template
        #header.action
      >
        <v-icon
          @click="onAddNewFormula"
        >add</v-icon>
      </template>

    </v-data-table>

    <drawer-dialog
      v-model="isUpserting"
      width="70%"
      max-width="1200px"
    >
      <level-formula-form-container
        v-if="isUpserting && formulaToEdit"
        :formula="formulaToEdit"
        :entities-by-id="entitiesById"
        @close="isUpserting = false"
        @reload="onReload"
      />
    </drawer-dialog>
  </div>
</template>

<script>
import LevelFormulaFormContainer from '../containers/LevelFormulaFormContainer.vue';
import { DrawerDialog } from '@/components/core/DrawerDialog';

export default {
  components: {
    DrawerDialog,
    LevelFormulaFormContainer
  },
  props: {
    levelFormulae: {
      type: Array,
      default: () => ([])
    },
    entitiesById: {
      type: Object,
      default: () => ({})
    },
    isLoading: Boolean
  },
  data() {
    return {
      headers: [
        { text: '#', value: 'formula_id', sortable: false },
        { text: 'Name', value: 'name' },
        { text: 'Period', value: 'settings.period' },
        { text: 'Start level', value: 'settings.start_level' },
        { text: 'Hold level', value: 'settings.hold_level' },
        { text: 'Slow drop', value: 'settings.slow_drop' },
        { text: 'Projects', value: 'entities' },
        { text: '', value: 'action', sortable: false },
      ],
      formulaToEdit: null,
      isUpserting: false,
    }
  },
  methods: {
    onAddNewFormula() {
      this.isUpserting = true;
      this.formulaToEdit = this.getEmptyFormula();
    },
    getEmptyFormula() {
      return {
        name: '',
        settings: {
          hold_level: false,
          period: '',
          start_level: 0,
          slow_drop: false,
          map: {},
          ratio: {},
          xp: {}
        },
        entities: []
      }
    },
    onReload() {
      this.isUpserting = false;
      this.$emit('reload');
    },

    getEntityList(entities) {
      return entities.map(entityId => this.entitiesById[entityId].text).join(', ');
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
